/* MOODLAG_ — theme.js : gallery, variant picker, AJAX cart, parallax, ticket notch, marquee */
(function () {
  'use strict';

  /* ---------- Cart count ---------- */
  function setCartCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-empty', n === 0);
    });
  }
  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCartCount(c.item_count); })
      .catch(function () {});
  }

  function addToCart(variantId, qty, btn) {
    var original = btn ? btn.textContent : null;
    if (btn) { btn.textContent = '...'; btn.disabled = true; }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { throw res.data; }
        refreshCartCount();
        openCart();
        if (btn) {
          btn.textContent = 'AJOUTÉ ✓';
          btn.style.background = 'var(--wh)';
          setTimeout(function () {
            btn.textContent = original; btn.style.background = ''; btn.disabled = false;
          }, 2200);
        }
        return res.data;
      })
      .catch(function (err) {
        if (btn) {
          btn.textContent = (err && err.description) ? 'INDISPONIBLE' : 'ERREUR';
          setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2200);
        }
      });
  }

  /* ---------- Product gallery ---------- */
  function initGallery() {
    var main = document.getElementById('pp-main-img');
    if (!main) return;
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-thumb]'));
    var dots = Array.prototype.slice.call(document.querySelectorAll('[data-dot]'));
    var srcs = thumbs.map(function (t) { return t.getAttribute('data-src'); });
    var current = 0, animating = false;

    function sync(idx) {
      thumbs.forEach(function (t, i) { t.classList.toggle('active', i === idx); });
      dots.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
    }
    function show(idx) {
      if (idx < 0 || idx >= srcs.length) return;
      current = idx;
      /* main-img porte un srcset/sizes figés sur l'image 1 (chargement responsive initial) :
         tant qu'ils restent en place, le navigateur privilégie srcset et ignore ce .src,
         donc l'image affichée ne change jamais. On les retire dès la première navigation. */
      main.removeAttribute('srcset'); main.removeAttribute('sizes');
      main.src = srcs[idx]; sync(idx);
    }
    function animate(newIdx, dir) {
      if (animating || newIdx === current || !srcs[newIdx]) return;
      animating = true;
      var container = main.closest('.pp-img');
      /* On ne construit le glissement qu'une fois la nouvelle image totalement prête
         (chargée + décodée). Avant ce correctif, l'élément "incoming" démarrait son
         glissement dès la création de l'<img>, pendant que le fichier (parfois >1 Mo)
         était encore en train de charger : il glissait donc à l'écran VIDE, puis le
         visuel apparaissait d'un coup au milieu ou à la fin du mouvement — exactement
         le sursaut "apparaît brusquement, disparaît, réapparaît" remonté par Paul. */
      var incoming = new Image();
      incoming.src = srcs[newIdx];
      var ready = incoming.decode ? incoming.decode().catch(function () {}) : new Promise(function (res) {
        if (incoming.complete) { res(); } else { incoming.onload = incoming.onerror = res; }
      });
      ready.then(function () {
        if (current !== newIdx) { animating = false; return; } /* une vignette/un point a changé la cible entre-temps */
        sync(newIdx);
        container.classList.add('animating');
        incoming.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;object-position:center center;transition:none;will-change:transform,filter;transform:translateX(' + (dir > 0 ? 100 : -100) + '%);';
        container.appendChild(incoming);
        main.style.willChange = 'transform,filter';
        void incoming.offsetWidth; /* commit la position de départ avant d'animer (pas de saut) */
        var DURATION = 520, MAX_BLUR = 12, start = null;
        function ease(t) { return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; }
        function frame(now) {
          if (!start) start = now;
          var t = Math.min((now - start) / DURATION, 1), e = ease(t);
          var bRaw = t < 0.5 ? t * 2 : (1 - t) * 2;
          var blur = (bRaw * bRaw * MAX_BLUR).toFixed(2);
          main.style.transform = 'translateX(' + (dir > 0 ? -(e * 100) : (e * 100)) + '%)';
          main.style.filter = 'blur(' + blur + 'px)';
          incoming.style.transform = 'translateX(' + (dir > 0 ? (1 - e) * 100 : -((1 - e) * 100)) + '%)';
          incoming.style.filter = 'blur(' + blur + 'px)';
          if (t < 1) { requestAnimationFrame(frame); }
          else {
            /* incoming est déjà chargée : le swap sur main est donc instantané, sans decode() à attendre. */
            main.removeAttribute('srcset'); main.removeAttribute('sizes');
            main.src = srcs[newIdx];
            main.style.transition = 'none'; main.style.transform = ''; main.style.filter = ''; main.style.willChange = '';
            incoming.remove();
            requestAnimationFrame(function () {
              main.style.transition = ''; container.classList.remove('animating'); animating = false;
            });
          }
        }
        requestAnimationFrame(frame);
      });
      current = newIdx;
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    var tscroll = document.getElementById('pp-thumbs-scroll');
    var tcol = document.querySelector('.pp-thumbs');
    if (tscroll && tcol) {
      var mainImg = document.querySelector('.pp-img');
      var updArrows = function () {
        var over = tscroll.scrollHeight > tscroll.clientHeight + 4;
        tcol.classList.toggle('has-overflow', over);
        tcol.classList.toggle('can-up', over && tscroll.scrollTop > 4);
        tcol.classList.toggle('can-down', over && (tscroll.scrollTop + tscroll.clientHeight < tscroll.scrollHeight - 4));
      };
      var syncH = function () {
        if (mainImg && window.innerWidth > 768) { tcol.style.maxHeight = mainImg.offsetHeight + 'px'; }
        else { tcol.style.maxHeight = ''; }
        updArrows();
      };
      syncH();
      tscroll.addEventListener('scroll', updArrows);
      window.addEventListener('resize', syncH);
      window.addEventListener('load', syncH);
      var _mi = document.getElementById('pp-main-img');
      if (_mi) { _mi.addEventListener('load', syncH); if (_mi.complete) syncH(); }
      setTimeout(syncH, 600);
    }
    dots.forEach(function (d, i) { d.addEventListener('click', function () { show(i); }); });
    var prev = document.querySelector('[data-prev]'), next = document.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { animate((current - 1 + srcs.length) % srcs.length, -1); });
    if (next) next.addEventListener('click', function () { animate((current + 1) % srcs.length, 1); });
  }

  /* ---------- Variant picker ---------- */
  function initVariantPicker() {
    var form = document.getElementById('product-form');
    if (!form) return;
    var jsonEl = form.querySelector('[data-variant-json]');
    var priceMapEl = form.querySelector('[data-variant-prices]');
    if (!jsonEl) return;
    var variants = JSON.parse(jsonEl.textContent);
    var priceMap = priceMapEl ? JSON.parse(priceMapEl.textContent) : {};
    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-price]');
    var availEl = document.querySelector('[data-availability]');
    var addBtn = form.querySelector('[data-add-btn]');
    var colorLabel = document.getElementById('color-label');

    var selected = { size: null, color: null };
    var sizeBtns = Array.prototype.slice.call(form.querySelectorAll('[data-option-size]'));
    var colorBtns = Array.prototype.slice.call(form.querySelectorAll('[data-option-color]'));
    var sizeActive = form.querySelector('[data-option-size].active');
    var colorActive = form.querySelector('[data-option-color].active');
    selected.size = sizeActive ? sizeActive.getAttribute('data-value') : null;
    selected.color = colorActive ? colorActive.getAttribute('data-value') : null;

    function findVariant() {
      return variants.find(function (v) {
        var okS = selected.size == null || v.options.indexOf(selected.size) !== -1;
        var okC = selected.color == null || v.options.indexOf(selected.color) !== -1;
        return okS && okC;
      });
    }
    function update() {
      var v = findVariant();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl && priceMap[v.id]) priceEl.innerHTML = priceMap[v.id];
      if (availEl) availEl.textContent = v.available ? 'EN STOCK' : 'ÉPUISÉ';
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'AJOUTER AU PANIER →' : 'ÉPUISÉ';
      }
      var stickyPrice = document.querySelector('[data-sticky-price]');
      var stickyAdd = document.querySelector('[data-sticky-add]');
      if (stickyPrice && priceMap[v.id]) stickyPrice.innerHTML = priceMap[v.id];
      if (stickyAdd) { stickyAdd.disabled = !v.available; stickyAdd.textContent = v.available ? 'AJOUTER →' : 'ÉPUISÉ'; }
    }
    sizeBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.classList.contains('out')) return;
        sizeBtns.forEach(function (x) { x.classList.remove('active'); });
        b.classList.add('active'); selected.size = b.getAttribute('data-value'); update();
      });
    });
    colorBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        colorBtns.forEach(function (x) { x.classList.remove('active'); });
        b.classList.add('active'); selected.color = b.getAttribute('data-value');
        if (colorLabel) colorLabel.textContent = b.getAttribute('data-value');
        update();
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!idInput || !idInput.value) return;
      addToCart(idInput.value, 1, addBtn);
    });
  }

  /* ---------- Quick add (cards) ---------- */
  function initQuickAdd() {
    document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var vid = btn.getAttribute('data-variant-id');
        if (vid) {
          addToCart(vid, 1, null);
          var o = btn.textContent;
          btn.textContent = '✓'; btn.style.background = 'var(--ye)'; btn.style.color = 'var(--bk)'; btn.style.borderColor = 'var(--ye)'; btn.style.opacity = '1';
          setTimeout(function () { btn.textContent = o; btn.style.background = ''; btn.style.color = ''; btn.style.borderColor = ''; }, 1600);
        } else {
          window.location.href = btn.getAttribute('data-product-url');
        }
      });
    });
  }

  /* ---------- Parallax hero ---------- */
  function initParallax() {
    var els = [document.getElementById('hero-photo'), document.getElementById('about-photo')].filter(Boolean);
    if (!els.length) return;
    window.addEventListener('scroll', function () {
      var y = 'translateY(' + (window.pageYOffset * 0.25) + 'px)';
      for (var i = 0; i < els.length; i++) { els[i].style.transform = y; }
    }, { passive: true });
  }

  /* ---------- Parallax sections mid-page (relatif au viewport) ----------
     07/09/2026 : généralisé de l'ID unique #ed-photo (section éditoriale) à tout
     élément portant [data-parallax-photo], pour réutiliser le même effet sur
     d'autres bandeaux photo (ex. header de la page Notre histoire) sans dupliquer
     la logique. #ed-photo continue de fonctionner (il porte aussi l'attribut). */
  function initSectionParallax() {
    var photos = document.querySelectorAll('[data-parallax-photo]');
    if (!photos.length) return;
    var entries = [];
    photos.forEach(function (ph) {
      entries.push({
        ph: ph,
        sec: ph.closest('.ed, .about__hero') || ph.parentElement,
        axis: ph.getAttribute('data-parallax-axis') === 'x' ? 'x' : 'y'
      });
    });
    function upd() {
      entries.forEach(function (e) {
        var r = e.sec.getBoundingClientRect();
        var delta = (window.innerHeight / 2 - (r.top + r.height / 2)) * 0.12;
        /* axe x : en descendant, delta croît — on l'inverse pour glisser vers la gauche */
        e.ph.style.transform = e.axis === 'x'
          ? 'translateX(' + (-delta).toFixed(1) + 'px)'
          : 'translateY(' + delta.toFixed(1) + 'px)';
      });
    }
    window.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  }

  /* ---------- Ticket notch ---------- */
  function positionNotch() {
    var btWrap = document.querySelector('.bt-wrap');
    var notch = document.getElementById('ticket-notch');
    var hero = document.querySelector('.hero');
    if (!btWrap || !notch || !hero) return;
    var b = btWrap.getBoundingClientRect(), h = hero.getBoundingClientRect();
    notch.style.top = (b.top - h.top + b.height * 0.54) + 'px';
    notch.style.transform = 'translateY(-50%)';
    notch.style.display = 'block';
  }

  /* ---------- Fade reveal (opt-in via .pre) ---------- */
  function initFade() {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (x) { if (x.isIntersecting) x.target.classList.add('in'); });
    }, { threshold: 0.06 });
    document.querySelectorAll('.fade.pre').forEach(function (el) { obs.observe(el); });
  }

  /* ---------- Lang switcher (decorative) ---------- */
  function initLang() {
    document.querySelectorAll('.topbar__lang a').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        document.querySelectorAll('.topbar__lang a').forEach(function (x) { x.classList.remove('active'); });
        this.classList.add('active');
      });
    });
  }

  /* ---------- Cart drawer ---------- */
  function money(cents, currency) {
    try { return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: currency || 'EUR' }).format((cents || 0) / 100); }
    catch (e) { return ((cents || 0) / 100).toFixed(2) + ' €'; }
  }
  function renderCart(cart) {
    var drawer = document.querySelector('[data-cart-drawer]'); if (!drawer) return;
    var itemsEl = drawer.querySelector('[data-drawer-items]');
    var foot = drawer.querySelector('[data-drawer-foot]');
    var countEl = drawer.querySelector('[data-drawer-count]');
    var cur = cart.currency || 'EUR';
    if (countEl) countEl.textContent = '(' + cart.item_count + ')';
    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<p class="cart-drawer__empty">Ton panier est vide.<br>Prêt au décollage ?</p>';
      if (foot) foot.hidden = true; return;
    }
    var html = '';
    cart.items.forEach(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '';
      var vt = (it.variant_title && it.variant_title !== 'Default Title') ? '<div class="cd-item__variant">' + it.variant_title + '</div>' : '';
      html += '<div class="cd-item">'
        + (img ? '<img class="cd-item__img" src="' + img + '" alt="">' : '<div class="cd-item__img"></div>')
        + '<div class="cd-item__main"><a class="cd-item__name" href="' + it.url + '">' + it.product_title + '</a>' + vt
        + '<div class="cd-item__row"><span class="cd-item__qty">'
        + '<button type="button" data-qty-dec data-key="' + it.key + '">−</button><span>' + it.quantity + '</span>'
        + '<button type="button" data-qty-inc data-key="' + it.key + '">+</button></span>'
        + '<span class="cd-item__price">' + money(it.final_line_price, cur) + '</span></div>'
        + '<button class="cd-item__remove" type="button" data-qty-rm data-key="' + it.key + '">RETIRER</button>'
        + '</div></div>';
    });
    itemsEl.innerHTML = html;
    var _sub = 0; cart.items.forEach(function (it) { _sub += (it.original_line_price || it.final_line_price || 0); });
    var sub = drawer.querySelector('[data-drawer-subtotal]'); if (sub) sub.textContent = money(_sub, cur);
    var mp = drawer.querySelector('[data-drawer-multiparcel]');
    if (mp) {
      var famMap = { 'T-shirt': 'tee', 'Hoodie': 'top', 'Sweatshirt': 'top', 'Mug': 'mug', 'Tote bag': 'bag', 'Casquette': 'cap' };
      var fams = {};
      cart.items.forEach(function (it) { fams[famMap[it.product_type] || 'x'] = 1; });
      mp.hidden = Object.keys(fams).length < 2;
    }
    if (foot) foot.hidden = false;
  }
  function openCart() {
    var drawer = document.querySelector('[data-cart-drawer]'); if (!drawer) return;
    drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false');
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }
  function closeCart() {
    var drawer = document.querySelector('[data-cart-drawer]'); if (!drawer) return;
    drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true');
  }
  function changeLine(key, qty) {
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(function (cart) { renderCart(cart); refreshCartCount(); }).catch(function () {});
  }
  function initCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]'); if (!drawer) return;
    document.querySelectorAll('[data-cart-toggle]').forEach(function (el) { el.addEventListener('click', function (e) { e.preventDefault(); openCart(); }); });
    drawer.querySelectorAll('[data-cart-close]').forEach(function (el) { el.addEventListener('click', closeCart); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });
    var checkout = drawer.querySelector('[data-drawer-checkout]'); if (checkout) checkout.addEventListener('click', function () { window.location.href = '/checkout'; });
    drawer.addEventListener('click', function (e) {
      var inc = e.target.closest('[data-qty-inc]'), dec = e.target.closest('[data-qty-dec]'), rm = e.target.closest('[data-qty-rm]');
      if (inc) { var s = inc.parentNode.querySelector('span'); changeLine(inc.getAttribute('data-key'), (parseInt(s.textContent, 10) || 1) + 1); }
      else if (dec) { var s2 = dec.parentNode.querySelector('span'); changeLine(dec.getAttribute('data-key'), Math.max(0, (parseInt(s2.textContent, 10) || 1) - 1)); }
      else if (rm) { changeLine(rm.getAttribute('data-key'), 0); }
    });
  }
  function initStickyBar() {
    var add = document.querySelector('[data-sticky-add]'), form = document.getElementById('product-form');
    if (!add || !form) return;
    add.addEventListener('click', function () {
      if (add.disabled) return;
      var idInput = form.querySelector('[data-variant-id]');
      if (idInput && idInput.value) addToCart(idInput.value, 1, add);
    });
  }

  function init() {
    initGallery();
    initVariantPicker();
    initQuickAdd();
    initParallax();
    initSectionParallax();
    initFade();
    initLang();
    initCartDrawer();
    initStickyBar();
    window.addEventListener('load', positionNotch);
    window.addEventListener('resize', positionNotch);
    positionNotch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();

/* ===== Vignette produit : cycle d'images au survol (ghost -> hero -> détail -> ghost) ===== */
(function(){
  var active=null, timer=null, idx=0, pending=null;
  function trk(b){ return b.querySelector('[data-pcard-track]'); }
  function zm(b){ return b.querySelector('.p-card__zoom'); }
  function bindEnd(t){ if(t.__b) return; t.__b=1; t.addEventListener('transitionend',function(ev){ if(ev.propertyName!=='transform') return; t.classList.remove('is-sliding'); var n=t.children.length; if(idx>=n-1){ idx=0; t.style.transition='none'; t.style.transform='translateX(0)'; void t.offsetWidth; } }); }
  function start(b){
    if(active===b) return;
    stop();
    active=b; idx=0;
    b.classList.add('is-hover');
    var t=trk(b), z=zm(b);
    /* zoom continu : démarre tout de suite, se poursuit pendant les glissements, ne redescend jamais */
    if(z){ z.style.transition='none'; z.style.transform='scale(1)'; void z.offsetWidth; z.style.transition='transform 7s ease-out'; z.style.transform='scale(1.15)'; }
    if(!t) return;
    bindEnd(t);
    t.style.transition='none'; t.style.transform='translateX(0)'; void t.offsetWidth;
    var n=t.children.length; if(n<2) return;
    function step(){
      idx++;
      t.style.transition='transform .55s cubic-bezier(.6,0,.2,1)';
      t.classList.add('is-sliding');          /* flou UNIQUEMENT pendant le déplacement latéral */
      t.style.transform='translateX(-'+(idx*100)+'%)';
    }
    /* Un survol "fantôme" (déclenché par le scroll qui fait apparaître une carte sous un
       curseur immobile, sans mouvement réel de la souris) ne doit pas faire sauter l'image :
       on attend un court instant, et seule une souris qui reste vraiment dessus voit le premier
       glissement. clearTimeout côté stop() annule ce délai si la carte n'a jamais été vraiment survolée. */
    pending=setTimeout(function(){ pending=null; step(); timer=setInterval(step,1500); },350);
  }
  function stop(){
    if(pending){ clearTimeout(pending); pending=null; }
    if(!active) return;
    clearInterval(timer); timer=null;
    var b=active, t=trk(b), z=zm(b);
    b.classList.remove('is-hover');
    if(t){ t.classList.remove('is-sliding'); t.style.transition='transform .4s ease'; t.style.transform='translateX(0)'; }
    if(z){ z.style.transition='transform .5s ease'; z.style.transform='scale(1)'; }
    idx=0; active=null;
  }
  document.addEventListener('mouseover',function(e){ var b=e.target.closest&&e.target.closest('[data-pcard]'); if(b&&b!==active) start(b); });
  document.addEventListener('mouseout',function(e){ if(!active) return; var to=e.relatedTarget; if(to&&active.contains(to)) return; stop(); });
  /* Le scroll fait apparaître de nouvelles cartes sous un curseur immobile : Chrome resynchronise
     alors :hover et déclenche un mouseover que l'utilisateur n'a jamais voulu. Sans ce filet, la
     carte reste bloquée sur l'image "hero" (aucun vrai mouseout ne survient tant que la souris ne
     bouge pas). Tout scroll annule donc l'aperçu en cours. */
  window.addEventListener('scroll',function(){ if(active||pending) stop(); },{passive:true,capture:true});
})();

/* ===== Page collection : filtres client-side ===== */
(function(){
  var shell=document.querySelector('.cat-shell'); if(!shell) return;
  var filters=shell.querySelector('[data-filters]');
  var grid=shell.querySelector('[data-grid]'); if(!grid) return;
  var cards=[].slice.call(grid.querySelectorAll('.p-card'));
  var countEls=[].slice.call(document.querySelectorAll('[data-result-count]'));
  var emptyEl=shell.querySelector('[data-empty]');
  function checked(g){ return [].slice.call(filters.querySelectorAll('input[data-f="'+g+'"]:checked')).map(function(i){return i.value;}); }
  function apply(){
    var fType=checked('type'),fSize=checked('size'),fColor=checked('color'),fPrice=checked('price'),fAvail=checked('avail');
    var shown=0;
    cards.forEach(function(c){
      var ok=true;
      if(fType.length) ok = fType.indexOf(c.dataset.type)>-1;
      if(ok && fSize.length){ var sz=(c.dataset.sizes||'').split('|'); ok=fSize.some(function(v){return sz.indexOf(v)>-1;}); }
      if(ok && fColor.length){ var co=(c.dataset.colors||'').split('|'); ok=fColor.some(function(v){return co.indexOf(v)>-1;}); }
      if(ok && fPrice.length){ var p=parseInt(c.dataset.price,10)||0; ok=fPrice.some(function(r){var b=r.split('-');return p>=+b[0]&&p<=+b[1];}); }
      if(ok && fAvail.length) ok = c.dataset.available==='1';
      c.style.display = ok ? '' : 'none';
      if(ok) shown++;
    });
    countEls.forEach(function(el){ el.textContent = shown + (shown>1?' PIÈCES':' PIÈCE'); });
    if(emptyEl) emptyEl.hidden = shown>0;
  }
  filters.addEventListener('change', function(e){
    if(e.target.matches('[data-sort]')){ var u=new URL(window.location.href); u.searchParams.set('sort_by', e.target.value); window.location.href=u.toString(); return; }
    apply();
  });
  var clear=filters.querySelector('[data-filter-clear]');
  if(clear) clear.addEventListener('click', function(){ [].slice.call(filters.querySelectorAll('input:checked')).forEach(function(i){i.checked=false;}); apply(); });
  var toggle=shell.querySelector('[data-filter-toggle]');
  if(toggle) toggle.addEventListener('click', function(){ filters.classList.toggle('is-open'); });
  /* pré-activation depuis l'URL : ?ft=<type> (lien fil d'ariane fiche produit) */
  try{
    var ft=new URLSearchParams(location.search).get('ft');
    if(ft){ var b=[].slice.call(filters.querySelectorAll('input[data-f="type"]')).filter(function(i){return i.value===ft.toLowerCase();})[0]; if(b) b.checked=true; }
  }catch(e){}
  apply();
})();
